

var vlResizeTimer;
var vlOverlayID = 'overlay';
var vlLightBoxID = 'vlLightBox'; 
var vlVideoID = 'vlVideo';
var vlVideoShowing = false;
var vlVideoTitle = '';
var vlVideoURL = '';
var vlVideoWidth = 0;
var vlVideoHeight = 0;
var vlLightboxMargin = 10; // margin around lightbox ie showing overlay underneath
var vlLightboxPadding = 10; // lightbox inner padding
var vlLightboxCloseHeight = 25;
var vlLightboxCaptionHeight = 60; // allow for caption
var vlVid;
var vlVidStartDelay = 250;
var vlScrollTop= 0; // remember where we are and return when finished with video (videos fixed position)



function vlSizeVideo(){
   if (vlVideoShowing == false){
       return false;
   }


   // window dimensions
   var wWidth = $(window).width();
   var wHeight = $(window).height();

   var maxWidth = wWidth - ((vlLightboxMargin + vlLightboxPadding) * 2);
   var maxHeight = wHeight - (((vlLightboxMargin + vlLightboxPadding) * 2) + vlLightboxCloseHeight + vlLightboxCaptionHeight);

   if (maxWidth>vlVideoWidth){maxWidth = vlVideoWidth}
   if (maxHeight>vlVideoHeight){maxHeight = vlVideoHeight}
   


   // adjust video to size
   var displayVW = vlVideoWidth;
   var displayVH = vlVideoHeight;

   if(displayVW > maxWidth){
       displayVW = maxWidth;
       displayVH = displayVW * vlVideoHeight / vlVideoWidth;
   }

   if(displayVH > maxHeight){
       displayVH = maxHeight;
       displayVW = displayVH * vlVideoWidth / vlVideoHeight;
   }

   // now set lightbox size
   var lbW = ((vlLightboxPadding * 2) + displayVW);
   var lbH = ((vlLightboxPadding * 2) + vlLightboxCloseHeight + vlLightboxCaptionHeight + displayVH);


   $('#' + vlLightBoxID).css('width',lbW+'px');
   $('#' + vlLightBoxID).css('height',lbH+'px');
   $('#' + vlLightBoxID).css('left',((wWidth - lbW) / 2)+'px');
   $('#' + vlLightBoxID).css('top',((wHeight - lbH) / 2)+'px');

   // lightboxInner
   $('#' + vlLightBoxID + ' .lightboxInner').css('width',lbW+'px');
   $('#' + vlLightBoxID + ' .lightboxInner').css('height',(lbH - vlLightboxCloseHeight) +'px');


   // and video
   
   $('#' + vlVideoID).css('width',displayVW+'px');
   $('#' + vlVideoID).css('height',displayVH+'px');
   $('#' + vlVideoID).css('left',vlLightboxPadding+'px');
   $('#' + vlVideoID).css('top',vlLightboxPadding+'px');
}




function vlShowVideo(vTitle,vWidth,vHeight,vURL){
	vlVideoTitle = vTitle;
    vlVideoShowing = true;
	vlVideoWidth = vWidth * 1; // in case string from data attribute
	vlVideoHeight = vHeight * 1; // in case string from data attribute
	vlVideoURL = vURL;
	vlSizeVideo();
	
    $('#' + vlVideoID + ' source').attr('src',vlVideoURL);
    $('#' + vlLightBoxID + ' .title').html(vlVideoTitle);
	vlScrollTop = $('html, body').scrollTop();
	$('html, body').scrollTop(0);
    $('#' + vlOverlayID).addClass('dark active');
    $('#' + vlLightBoxID).addClass('active');
    vlVid.src = vlVideoURL;
    setTimeout(function(){vlVid.play()},vlVidStartDelay);
}

export function vlHandleResize(){
  $(window).resize(function(){
     clearTimeout(vlResizeTimer);
     vlResizeTimer = setTimeout(function(){
        vlSizeVideo();
     },500);
  });
}

export function vlAddLightBox(){
	var lb = '';
	lb += '<div id="' + vlLightBoxID + '">';
	lb += '<div class="lightboxClose">X</div>';
	lb += '<div class="lightboxInner">';
	lb += '   <video controls="" id="' + vlVideoID + '" playsinline="">';
	lb += '     <source type="video/mp4"></source>';
	lb += '   </video>';
	lb += '   <div class="title">&nbsp;</div>';
	lb += '   </div>';
	lb += '</div>';
	$('body').append(lb);
	vlVid = document.getElementById(vlVideoID);
}

export function vlSetCloser(){
   $('#' + vlLightBoxID + ' .lightboxClose').click(function(){
      vlVid.pause();
	  $('html, body').scrollTop(vlScrollTop);
      $('#' + vlOverlayID).removeClass('dark active');
      $('#' + vlLightBoxID).removeClass('active');
	  vlVideoShowing = false;
   });
}


export function vlPrepareVideos(){
   $('div[data-type="vl-video"]').click(function(){
      console.log(this);
      
      let $vid = $(this);
      var vW = $vid.attr('data-video-width');
      var vH = $vid.attr('data-video-height');
      var vURL = $vid.attr('data-videourl');
      var vTitle = $vid.attr('data-video-title');
      vlShowVideo(vTitle,vW,vH,vURL);
   });
}

// $(document).ready(function(){
//    vlAddLightBox();
//    vlHandleResize();
//    vlSetCloser();
//    vlPrepareVideos();
// });